export default __webpack_public_path__ + "static/media/insights-landing-hero.8f9cefd8.svg";